<mat-toolbar class="mat-primary">
  <span fxFlex>{{ actionName }}</span>
  <mat-icon class="cursor-mat-element" (click)="cancel()">close</mat-icon>
</mat-toolbar>
<mat-dialog-content>
  <div flex fxLayout="column" fxLayoutAlign="center">
    <strong>Empfänger</strong>
    <p style="font-size: 0.8rem; margin-bottom: 0.5rem">{{ recipients }}</p>
    <strong>Betreff der E-Mail</strong>
    <p style="font-size: 0.8rem; margin-bottom: 0.5rem">{{ subject }}</p>

    <ng-container *ngIf="dialogInfoText">
      <p>{{ dialogInfoText }}</p>
    </ng-container>
    <ng-container *ngIf="!hideCommentField">
      <mat-form-field fxFlex="100">
        <mat-label>Kommentar mitgeben</mat-label>
        <textarea matInput type="text" rows="3" [(ngModel)]="comment"></textarea>
      </mat-form-field>
    </ng-container>
  </div>

  <div class="button-container" fxLayout="row" fxLayoutAlign="end stretch" fxLayoutGap="20px">
    <button mat-stroked-button color="primary" id="modal-cancel-button" (click)="cancel()">Abbrechen</button>

    <button mat-raised-button color="primary" id="modal-confirm-button" (click)="confirm()">
      {{ actionName }}
    </button>
  </div>
</mat-dialog-content>
